import axios        from 'axios';
import authHeader   from 'services/auth-header';

class AuditLogService  {
  auditLogs(params) {
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + 'audit_logs', { headers: authHeader(), params: params })
      .then(response => {
        return response.data;
      }
    );
  }
}

export default new AuditLogService();